import { useState, useEffect, useCallback } from "react";
import Container from "../common/Container";
import Button from "../common/Button";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { site } from "../../data/siteData";
import "../../styles/Hero.css";

const slides = [
  {
    image: site.images.hero,
    subtitle: "Welcome to Crown Star",
    title: "Cleaning that looks premium — every visit.",
    description: "Crown Star Facility Services for homes, offices, and end-of-lease. Consistent quality, clear communication, and on-time service."
  },
  {
    image: site.images.hero2, 
    subtitle: "Expert Facility Care",
    title: "A pristine environment for a better life.",
    description: "We help you feel better and enjoy every single day of your life in a clean, professionally maintained environment."
  }
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const nextSlide = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    setTimeout(() => setIsAnimating(false), 1000);
  }, [isAnimating]);

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    setTimeout(() => setIsAnimating(false), 1000);
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 6000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section id="home" className="hero-slider">
      {/* Background Images */}
      {slides.map((slide, index) => (
        <div 
          key={index} 
          className={`slide-item ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `linear-gradient(to right, rgba(0,12,26,0.8) 20%, rgba(0,30,61,0.3)), url(${slide.image})` }}
        />
      ))}

      {/* Optimized Arrow Shape */}
      <div className={`hero-glass-overlay ${isAnimating ? "pulse" : ""}`}></div>

      <Container>
        <div className="hero-content-wrapper">
          <div className="hero-text-content" key={current}>
            <span className="hero-subtitle">{slides[current].subtitle}</span>
            <h1 className="hero-title">{slides[current].title}</h1>
            <p className="hero-description">{slides[current].description}</p>
            
            <div className="hero-btns">
              <Button as="a" href="#contact" variant="primary" size="lg" className="hero-btn-main">
                 Book a Service
              </Button>
              <Button as="a" href="#pricing" variant="outline" size="lg" className="hero-btn-sub">
                 View Pricing
              </Button>
            </div>
          </div>
        </div>
      </Container>

      {/* Modern Controls */}
      <div className="slider-navigation">
        <div className="slider-counter">
          <span className="current-idx">0{current + 1}</span>
          <div className="counter-line"></div>
          <span className="total-idx">0{slides.length}</span>
        </div>
        <div className="slider-arrows">
          <button onClick={prevSlide} className="nav-btn"><FaChevronLeft /></button>
          <button onClick={nextSlide} className="nav-btn"><FaChevronRight /></button>
        </div>
      </div>
    </section>
  );
}